// src/pages/CartTotal.jsx
import React, { useContext } from 'react';
import { ShopContext } from "../context/ShopContext.jsx";
import { Box, Typography, Divider } from '@mui/material';

const CartTotal = () => {
  const { currency, delivery_fee, getCartAmount } = useContext(ShopContext);

  const subtotal = getCartAmount();
  const total = subtotal === 0 ? 0 : subtotal + delivery_fee;

  return (
    <Box
      sx={{
        mt: 4,
        p: 2,
        border: '1px solid #ddd',
        borderRadius: 2,
      }}
    >
      <Typography variant="h5" component="h2" fontWeight="bold" gutterBottom>
        Cart Total
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', my: 1 }}>
        <Typography variant="body1">Subtotal</Typography>
        <Typography variant="body1">
          {currency}{subtotal}.00
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', my: 1 }}>
        <Typography variant="body1">Shipping Fee</Typography>
        <Typography variant="body1">
          {currency}{delivery_fee}.00
        </Typography>
      </Box>
      <Divider sx={{ my: 1 }} />
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          Total
        </Typography>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {currency}{total}.00
        </Typography>
      </Box>
    </Box>
  );
};

export default CartTotal;
